import styles from "./styles.module.css";
import { FaRegCircleQuestion } from "react-icons/fa6";
import { NavLink } from "react-router-dom";
import { MdErrorOutline, MdLock } from "react-icons/md";
import { ChinaUrlCode, USUrlCode } from "../../utils/ControllerCostant";
import {
  chinaEmail,
  globalEmail,
  subject,
  usEmail,
} from "../../utils/constants";

const ErrorPage = ({ type, title, description, imgUrl }) => {
  const location = window.location.hostname;
  let mailToLink;
  if (location.includes(USUrlCode))
    mailToLink = `mailto:${usEmail}?subject=${encodeURIComponent(subject)}`;
  else if (location.includes(ChinaUrlCode))
    mailToLink = `mailto:${chinaEmail}?subject=${encodeURIComponent(subject)}`;
  else
    mailToLink = `mailto:${globalEmail}?subject=${encodeURIComponent(subject)}`;
  return (
    <div className={styles["page-wrapper"]}>
      {type === "404" && (
        <MdErrorOutline size={35} className={styles["error_icon"]} />
      )}
      {type === "accessDenied" && (
        <MdLock size={35} className={styles["accessdenied_icon"]} />
      )}

      <p className={styles["title"]}>{title}</p>
      <p className={styles["message"]}>{description}</p>
      {type === "404" && (
        <NavLink to="/ui/identity-management" className={styles["error_link"]}>
          Return to Identity Management
        </NavLink>
      )}
      <a href={mailToLink} className={styles["error_btn"]}>
        <span className="d-flex align-items-center">
          <FaRegCircleQuestion className="fa_error ps-1" size={22} />
          <span className="px-2">Contact Us</span>
        </span>
      </a>
      <img src={imgUrl} alt="error-image" />
    </div>
  );
};

export default ErrorPage;
